import { render, staticRenderFns } from "./vendor-project-list.vue?vue&type=template&id=0efa547c&scoped=true&"
import script from "./vendor-project-list.vue?vue&type=script&lang=js&"
export * from "./vendor-project-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa547c",
  null
  
)

export default component.exports